export default __webpack_public_path__ + "static/media/cactus.67b37f11.png";